var _defs, _circle, _circle2, _circle3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#eef3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d4ddec"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#bg)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "none",
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 11,
    fill: "#3f4652"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 52c1-9.5 7.8-16 14-16s13 6.5 14 16c0.2 1.3-0.3 2-1.8 2H19.8c-1.5 0-2-0.7-1.8-2z",
    fill: "#555c68",
    style: {
      paintOrder: "stroke"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 36,
    rx: 8,
    ry: 3,
    fill: "rgba(0,0,0,0.08)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfilePicture);
export default __webpack_public_path__ + "static/media/default-profile-picture.b8cf23a360036e8e2abccec3d7e50f6a.svg";
export { ForwardRef as ReactComponent };